import {Mapper} from '@s-ui/domain'

export class FromVehicleCertificationRawDataToVehicleCertificationVOMapper extends Mapper {
  constructor({
    config,
    fromVehicleCertificationFeaturesListRawDataToVehicleCertificationFeaturesListVOMapper,
    vehicleCertificationValueObject
  }) {
    super()
    this._config = config
    this._fromVehicleCertificationFeaturesListRawDataToVehicleCertificationFeaturesListVOMapper =
      fromVehicleCertificationFeaturesListRawDataToVehicleCertificationFeaturesListVOMapper
    this._vehicleCertificationValueObject = vehicleCertificationValueObject
  }

  setCertificatedProgramId = ({certificatedProgramId}) => {
    this._certificatedProgramId = certificatedProgramId
    return this
  }

  setFeatures = ({features}) => {
    this._features = features
    return this
  }

  setLogoUrl = ({logoUrl}) => {
    this._logoUrl = logoUrl
    return this
  }

  setMake = ({make}) => {
    this._make = make
    return this
  }

  map = () => {
    const featuresListVO = this._fromVehicleCertificationFeaturesListRawDataToVehicleCertificationFeaturesListVOMapper
      .setFeaturesList({featuresList: this._features})
      .map()
    const features = featuresListVO.getItems()
    return this._vehicleCertificationValueObject({
      certificatedProgramId: this._certificatedProgramId,
      features,
      logoUrl: this._logoUrl,
      make: this._make
    })
  }
}
